import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class Helper {
  constructor() {
  }


  fillTemplatePlaceholders(template: string, values: { [key: string]: any }): string {
    return template.replace(/\{(\w+)\}/g, (match, key) => {
      if(values[key] !== undefined){
        if(values[key] === null){
          return '';
        }
        if(values[key] instanceof DateTime){
          return (values[key] as DateTime).toFormat(environment.AppConfig.DateFormats.display.dateInput);
        } else if(Array.isArray(values[key])){
          return values[key].join(', ');
        } else {
          return values[key];
        }
      } else {
        return match;
      }
    });
  }

  getNavItems() {
    let toReturn = [];

    const heroConfig = environment.HeroConfig as any;
    if(heroConfig && heroConfig.navName) {
      toReturn.push({
        title: heroConfig.navName,
        url: '#' + heroConfig.id,
      });
    }

    const aboutConfig = environment.AboutConfig as any;
    if(aboutConfig && aboutConfig.navName) {
      toReturn.push({
        title: aboutConfig.navName,
        url: '#' + aboutConfig.id,
      });
    }

    const featureConfig = environment.FeatureConfig as any;
    if(featureConfig && featureConfig.navName) {
      toReturn.push({
        title: featureConfig.navName,
        url: '#' + featureConfig.id,
      });
    }

    const activitiesConfig = environment.ActivitiesConfig as any;
    if(activitiesConfig && activitiesConfig.navName) {
      toReturn.push({
        title: activitiesConfig.navName,
        url: '#' + activitiesConfig.id,
      });
    }

    const galleryConfig = environment.GalleryConfig as any;
    if(galleryConfig && galleryConfig.navName) {
      toReturn.push({
        title: galleryConfig.navName,
        url: '#' + galleryConfig.id,
      });
    }

    const reviewConfig = environment.ReviewConfig as any;
    if(reviewConfig && reviewConfig.navName) {
      toReturn.push({
        title: reviewConfig.navName,
        url: '#' + reviewConfig.id,
      });
    }

    const contactConfig = environment.ContactConfig as any;
    if(contactConfig && contactConfig.navName) {
      toReturn.push({
        title: contactConfig.navName,
        url: '#' + contactConfig.id,
      });
    }

    const bookingConfig = environment.BookingConfig as any;
    if(bookingConfig && bookingConfig.navName) {
      toReturn.push({
        title: bookingConfig.navName,
        url: '#' + bookingConfig.id,
      });
    }
    return toReturn;
  }
}
